import { InsertLinkProperties } from './components/buttons/insertLink';
import { ContextualFormatBarProps } from './components/ContextualFormatBar';
import { RibbonProps } from './components/Ribbon';

import RibbonPlugin from './plugin/RibbonPlugin';
import RibbonFormatState from './store/schema/RibbonFormatState';
import RibbonViewState from './store/schema/RibbonViewState';
import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { ComponentClass } from 'react';
import { FormatState } from 'roosterjs-editor-types';
export { ComponentClass };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "HtmlEditor", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export let Ribbon = createLazyComponent(lazyModule, m => m.Ribbon);
export let ContextualFormatBar = createLazyComponent(lazyModule, m => m.ContextualFormatBar);

// Delay loaded actions
export let lazyUpdateRibbonWidth = new LazyAction(lazyModule, m => m.updateRibbonWidth);

// Delay load utils
export let lazyUpdateRibbonState = new LazyImport(lazyModule, m => m.updateRibbonState);
export let lazyFormatPainterFinish = new LazyImport(lazyModule, m => m.formatPainterFinish);
export let lazyShowInsertLinkDialog = new LazyImport(lazyModule, m => m.showInsertLinkDialog);
export let lazyDisplayInsertLinkDialog = new LazyImport(lazyModule, m => m.displayInsertLinkDialog);
export let lazyShowImageAltTextDialog = new LazyImport(lazyModule, m => m.showImageAltTextDialog);

// export synchronous interfaces
export {
    RibbonProps,
    ContextualFormatBarProps,
    RibbonPlugin,
    RibbonViewState,
    FormatState,
    RibbonFormatState,
    InsertLinkProperties,
};
